import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ManagePukalService } from '../../../../services/manage-pukal.service';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';

@Component({
    selector: 'dialog-ngr-addnewaccount',
    templateUrl: 'dialog.addnewaccount.html',
    styleUrls: ['dialog.addnewaccount.css']
})
export class AddNewAccountPukalStateGovernmentDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    isSubmit: boolean = false;
    addnewaccform: FormGroup;
    errorMessage: string = '';
    warrant_auth_code: string = 'NG';
    agencyCodes = [];
    accoffices = [];
    objects = [];
    activations = [];

    constructor(public dialogRef: MatDialogRef<AddNewAccountPukalStateGovernmentDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private managePukalService: ManagePukalService,
        public snackBar: MatSnackBar) { }

    ngOnInit() {
        this.addnewaccform = new FormGroup({
            selectedagency: new FormControl({ value: '', disabled: false }, Validators.required),
            selectedaccoff: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.min(1)]),
            ptjaddress: new FormControl({ value: '', disabled: false }, Validators.required),
            pukalnumber: new FormControl({ value: '', disabled: true }),
            warrantdepartment: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(4)]),
            warrantptj: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(8)]),
            vote: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(3)]),
            chargedeparment: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(4)]),
            changeptj: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(8)]),
            vpa: new FormControl({ value: '', disabled: false }, Validators.maxLength(6)),
            vpss: new FormControl({ value: '', disabled: false }, Validators.maxLength(12)),
            cp: new FormControl({ value: '', disabled: false }, Validators.maxLength(1)),
            selectedobject: new FormControl({ value: '', disabled: false }, Validators.required),
            selectedactivation: new FormControl({ value: '', disabled: false }, Validators.required),
            setia: new FormControl({ value: '', disabled: false }, [Validators.maxLength(12)])
        });

        let init_sub = this.managePukalService.getAddPukalAccountLoad(this.warrant_auth_code)
            .subscribe(
                (data) => {
                    this.agencyCodes = data.agentCodes;
                    this.accoffices = data.accountOffices;
                    this.objects = data.janObject;
                    this.activations = data.accountStatus;

                    this.addnewaccform.setValue({
                        selectedagency: data.agentCodes[0].Airline_Agency_Code,
                        selectedaccoff: '',
                        ptjaddress: '',
                        pukalnumber: 'System Generate',
                        warrantdepartment: '',
                        warrantptj: '',
                        vote: '',
                        chargedeparment: '',
                        changeptj: '',
                        vpa: '',
                        vpss: '',
                        cp: '',
                        selectedobject: data.janObject[0].Obj_Id,
                        selectedactivation: data.accountStatus[0].StatusCode,
                        setia: ''
                    });
                },
                error => {
                    this.errorMessage = <any>error;
                    this.openSnackBar(this.errorMessage, '');
                });

        //Adds into array for each subscribe
        this.allSub.push(init_sub);
    }

    onSubmit(form: FormGroup) {
        let cfm = confirm("Are you sure you want to add new Pukal Account?");

        if (cfm) {
            this.isSubmit = true;

            let newPukalAccount = {
                Acc: this.addnewaccform.get('ptjaddress')!.value,
                Acc_Off_Code: this.addnewaccform.get('selectedaccoff')!.value,
                Acc_Sts_Code: this.addnewaccform.get('selectedactivation')!.value,
                Airline_Agency_Code: this.addnewaccform.get('selectedagency')!.value,
                Charge_Dept: this.addnewaccform.get('chargedeparment')!.value,
                Charge_RCCC: this.addnewaccform.get('changeptj')!.value,
                CP: this.addnewaccform.get('cp')!.value,
                Objects: this.addnewaccform.get('selectedobject')!.value,
                Program: this.addnewaccform.get('vpa')!.value,
                Project: this.addnewaccform.get('vpss')!.value,
                Vote: this.addnewaccform.get('vote')!.value,
                Warrant_Dept: this.addnewaccform.get('warrantdepartment')!.value,
                Warrant_RCCC: this.addnewaccform.get('warrantptj')!.value,
                Setia: this.addnewaccform.get('setia')!.value
            }

            let save_sub = this.managePukalService.NGRAddNewPukalAccount(newPukalAccount)
                .subscribe(
                    (data) => {
                        this.dialogRef.close('Add new successful');
                    },
                    error => {
                        this.errorMessage = <any>error;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(save_sub);
        } else {
            this.isSubmit = false;
        }
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}